// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { slideshowStyles } from "@stoneage/Overrides/Widgets/Basic/Slideshow";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        padding: 16px 0;
        width: 100%;
        ${xScreen("lte", "sm")} {
            bottom: -50px;
            z-index: 2;
            align-items: center;
        }
    `,
};

slideshowStyles.prevArrowButton = {
    css: css`
        border: 0;
        padding: 0;
        min-height: 44px;
        width: 44px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        && {
            background: rgba(255, 255, 255, 0.8);
        }
        &:hover {
            background: #587A81 !important;
            &&& svg {
                color: ${getColor('common.white')};
            }
        }
        &:focus {
            background:#587A81 !important;
            outline: none;
            &&& svg {
                color: ${getColor('common.white')};
            }
        }
        &&& ${IconWrapper}, &&& ${IconWrapper} svg {
            width: 20px;
            height: 20px;
            color: #587A81;
            stroke-width: 4px;
        }
        &.slide-arrow-mobile-prev {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            display: none;
            &&&.slide-arrow-mobile-prev {
                display: block;
                background: transparent !important;
                min-height: auto;
                width: auto;
                padding: 0;
                border: 0;
                margin-right: 10px;
                && svg {
                    color: ${getColor("common.ui7")};
                }
            }
        }
    `,
};

slideshowStyles.nextArrowButton = {
    css: css`
    border: 0;
    padding: 0;
    min-height: 44px;
    width: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    && {
        background: rgba(255, 255, 255, 0.8);
    }
    &:hover {
        background: #587A81 !important;
        &&& svg {
            color: ${getColor('common.white')};
        }
    }
    &:focus {
        background: #587A81 !important;
        outline: none;
        &&& svg {
            color: ${getColor('common.white')};
        }
    }
    &&& ${IconWrapper}, &&& ${IconWrapper} svg {
        width: 20px;
        height: 20px;
        color: #587A81;
        stroke-width: 4px;
    }
    &.slide-arrow-mobile-next {
        display: none;
    }
    ${xScreen("lte", "sm")} {
        display: none;
        &&&.slide-arrow-mobile-next {
            display: block;
            background: transparent !important;
            min-height: auto;
            width: auto;
            padding: 0;
            border: 0;
            margin-left: 10px;
            &&& svg {
                color: ${getColor("common.ui7")};
            }
        }
    }
`,
};